import React, { Component } from 'react'
import { Breadcrumb, Input, Button, message, Modal } from 'antd';
import { deleteCaseByIds, inspiration_es_batchDelIns,showHomePage, reshelfCaseByIds } from "../../api";

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collIds: '',
            insIds: '',
            hideCaseIds: '',
            reshelfIds: '',
        }
    }

    handleChange_collIds = (event) => {
        this.setState({ collIds: event.target.value });
    };
    handleChange_insIds = (event) => {
        this.setState({ insIds: event.target.value });
    };
    handleChange_hideCaseIds = (event) => {
        this.setState({ hideCaseIds: event.target.value });
    };
    //批量重新上架
    handleChange_reshelf = (event) => {
        this.setState({reshelfIds: event.target.value});
    }
    success = (data) => {
        Modal.success({
            content: '全部处理完毕!',
        });
    };

    del_insIds = async () => {
        const insIds = this.state.insIds;
        let array = insIds.split('\n');
        message.loading('删除中...', 0);
        await deleteCaseByIds(array).then((res) => {
            if (res.error.errorCode == 0) {
                message.destroy();
                this.success(res.data)
            } else {
                message.error(res.error.errorMsg);
            }
        }).catch((e) => {
            message.destroy();
            message.error('数据格式错误')
        });
    };

    // 隐藏案例接口 案例日报显示设置
    hideCaeId = async () => {
        const hideCaseIds = this.state.hideCaseIds;
        let array = hideCaseIds.split('\n');
        message.loading('处理中...', 0);
        await showHomePage(array).then((res) => {
            if (res.error.errorCode == 0) {
                message.destroy();
                this.success(res.data)
            } else {
                message.error(res.error.errorMsg);
            }
        }).catch((e) => {
            message.destroy();
            message.error('数据格式错误')
        });
    }
    // 批量重新上架
    reshelfIds = async () => {
        const reshelfIds = this.state.reshelfIds;
        let array = reshelfIds.split('\n');
        message.loading('重新上架中...', 0);
        console.log(array);
        await reshelfCaseByIds(array).then((res)=>{
            if (res.error.errorCode == 0) {
                message.destroy();
                this.success(res.data)
            } else {
                message.error(res.error.errorMsg);
            }
        }).catch((e) => {
            console.log(e);
            message.destroy();
            message.error('数据格式错误')
        })
    }
    render() {
        const { collIds, insIds,reshelfIds ,hideCaseIds } = this.state;
        return <div>
            {/* <p /> */}
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        案例下架管理
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            {/* <p /> */}
            <div>
                <label>案例 ID：</label>
                <Input.TextArea autoSize={{ minRows: 8, maxRows: 100000 }} allowClear={true}
                    placeholder={'使用说明:\r\n多个id请换行存放\r\n示例:\r\n1\r\n2\r\n3\r\nps:请勿以换行结尾'}
                    onChange={this.handleChange_insIds} value={insIds} />
                <p />
                <Button type="danger" onClick={this.del_insIds}>下架</Button>
                <p />
            </div>


            {/* <p /> */}
        
        <div>
        <Breadcrumb>
            <Breadcrumb.Item>
                案例重新上架管理
            </Breadcrumb.Item>
        </Breadcrumb>
        </div>
        <div>
            <label>案例 ID：</label>
            <Input.TextArea autoSize={{ minRows: 8, maxRows: 100000 }} allowClear={true}
                placeholder={'使用说明:\r\n多个id请换行存放\r\n示例:\r\n1\r\n2\r\n3\r\nps:请勿以换行结尾'}
                onChange={this.handleChange_reshelf} value={reshelfIds} />
            <p />
            <Button type="danger" onClick={this.reshelfIds}>重新上架</Button>
            <p />
        </div>

        <div>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        案例日报隐藏管理
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div>
                <label>案例 ID：</label>
                <Input.TextArea autoSize={{ minRows: 8, maxRows: 100000 }} allowClear={true}
                    placeholder={'使用说明:\r\n多个id请换行存放\r\n示例:\r\n1\r\n2\r\n3\r\nps:请勿以换行结尾'}
                    onChange={this.handleChange_hideCaseIds} value={hideCaseIds} />
                <p />
                <Button type="danger" onClick={this.hideCaeId}>隐藏</Button>
                <p />
            </div>
            
        </div>

    }
}

export default Index
